/*
 * @Copyright: @ Silk Software Corp. All Rights Reserved Based on SILK-LICENSE
 */
/**
 * Custom type policies that allow us to have more granular control
 * over how ApolloClient reads from and writes to the cache.
 *
 * https://www.apollographql.com/docs/react/caching/cache-configuration/#typepolicy-fields
 * https://www.apollographql.com/docs/react/caching/cache-field-behavior/
 */
export const typePolicies = {
  // Query/Mutation are "types" just like "Cart".
  Query: {
    fields: {
      site: {
        merge(existing, incoming, { mergeObjects }) {
          // Correct, thanks to invoking nested merge functions.
          return mergeObjects(existing, incoming)
        }
      }
    }
  }
}
